import { useEffect, useState } from "react"
import DataTable from "@/widgets/DataTable"
import {
    getAdminsForApprover,
    bulkSetCourseApprovers
} from "@/api/kuizy"

export default function CourseApproverDetailModal({
    visible,
    courseId,
    courseName,
    onClose,
}) {
    const [rows, setRows] = useState([])
    const [selectedSet, setSelectedSet] = useState(new Set())
    const [loading, setLoading] = useState(false)

    const [search, setSearch] = useState("")
    const [page, setPage] = useState(1)
    const [perPage, setPerPage] = useState(10)
    const [total, setTotal] = useState(0)

    const fetchList = async () => {
        if (!visible) return
        setLoading(true)
        const res = await getAdminsForApprover({
            course_ids: courseId,
            search,
            page,
            per_page: perPage,
        })

        setRows(res.data.rows)
        setTotal(res.data.total)

        const pre = new Set(
            res.data.rows
                .filter(r => r.is_approver)
                .map(r => r.id)
        )

        setSelectedSet(pre)
        setLoading(false)
    }

    useEffect(() => {

        fetchList()
    }, [visible, courseId, page, perPage])


    const handleSave = async () => {
        await bulkSetCourseApprovers([courseId], [...selectedSet])
        onClose()
    }
    if (!visible) return null

    return (
        <div className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm flex items-center justify-center">
            <div className="bg-white w-[95vw] h-[90vh] rounded-2xl shadow-2xl flex flex-col overflow-hidden">

                <div className="px-6 py-4 border-b flex justify-between items-start bg-gray-50">
                    <div>
                        <h2 className="text-lg font-semibold">
                            จัดการผู้อนุมัติ
                        </h2>
                        <p className="text-sm text-gray-600 mt-1">
                            หลักสูตร:
                            <span className="font-medium text-gray-900 ml-1">
                                {courseName || "-"}
                            </span>
                        </p>
                    </div>

                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-black text-lg"
                    >
                        ✕
                    </button>
                </div>

                <div className="px-6 py-4 border-b bg-white flex gap-3 items-center">
                    <input
                        placeholder="ค้นหา admin จากชื่อ หรือ email..."
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        onKeyDown={e => e.key === "Enter" && (setPage(1), fetchList())}
                        className="flex-1 border border-gray-300 rounded-lg px-4 py-2 text-sm focus:ring-2 focus:ring-primary"
                    />

                    <button
                        onClick={() => { setPage(1); fetchList() }}
                        className="bg-primary hover:bg-secondary text-white px-4 py-2 rounded-lg text-sm"
                    >
                        ค้นหา
                    </button>
                </div>

                <div className="flex-1 p-6 min-h-0">
                    <DataTable
                        columns={[
                            { key: "full_name", title: "ชื่อ" },
                            { key: "email", title: "Email" },
                        ]}
                        rows={rows}
                        loading={loading}
                        selectable
                        selectedSet={selectedSet}
                        onToggleRow={(key) => {
                            const s = new Set(selectedSet)
                            s.has(key) ? s.delete(key) : s.add(key)
                            setSelectedSet(s)
                        }}
                        rowKey={(row) => row.id}
                        page={page}
                        perPage={perPage}
                        total={total}
                        onPageChange={setPage}
                        onPerPageChange={(val) => {
                            setPage(1)
                            setPerPage(val)
                        }}
                    />
                </div>

                <div className="border-t px-6 py-4 flex justify-end gap-3">
                    <button onClick={onClose} className="border px-4 py-2 rounded">
                        ยกเลิก
                    </button>
                    <button
                        onClick={handleSave}
                        className="bg-primary text-white px-4 py-2 rounded"
                    >
                        บันทึก
                    </button>
                </div>

            </div>
        </div>
    )
}
